module.exports = __webpack_public_path__ + "img/Davies.f067bf03.png";